import { PrinterOutlined } from "@ant-design/icons";
import { Button, Col, Flex, message, Row, Skeleton } from "antd";
import dayjs from "dayjs";
import PropTypes from "prop-types";
import { useEffect, useState } from "react";
import ReactQuill from "react-quill-new";
import API from "../services/api-request";
import { getDataLogin } from "../utils/getDataLogin";

import "react-quill-new/dist/quill.snow.css";
import UserManualButton from "./UserManualButton";

const modules = {
  toolbar: {
    container: [
      [{ header: [1, 2, 3, false] }],
      ["bold", "italic", "underline"],
      [
        { align: "" },
        { align: "center" },
        { align: "right" },
        { align: "justify" },
      ],
      [{ color: [] }, { background: [] }],
      [{ list: "ordered" }, { list: "bullet" }],
      ["image"],
    ],
  },
};

const PolicyComponent = ({ isPublic }) => {
  const [value, setValue] = useState(null);
  const [isSaved, setIsSaved] = useState(true);
  const [savedDate, setSavedDate] = useState(null);
  const [isStaff, setIsStaff] = useState(false);
  const [loading, setLoading] = useState(false);

  const getDocumentData = () => {
    setLoading(true);

    API.Get("content/policy")
      .then((res) => {
        const content = res?.data?.content;
        setValue(content);
        setSavedDate(dayjs(res?.data?.updated_at).format("YYYY-MM-DD"));
      })
      .catch((err) => {
        message.error("Failed to fetch policy!");
        console.log(err);
      })
      .finally(() => setLoading(false));
  };

  const handleSave = () => {
    setLoading(true);

    const formData = {
      type: "policy",
      slug: "policy",
      title: "Policy",
      content: value,
    };

    API.Post("content", formData)
      .then((res) => {
        message.success("New Policy saved!");
      })
      .catch((err) => {
        message.error("Failed to save policy! Please try again later.");
        console.log(err);
      })
      .finally(() => {
        setLoading(false);
        setIsSaved(true);
        getDocumentData();
      });
  };

  const handleEdit = () => {
    setIsSaved(false);
  };

  const handlePrint = () => {
    const printableContent = document.getElementById("printable").innerHTML;

    const newWindow = window.open("", "_blank", "width=800,height=600");
    const printMarkup = `
    <html>
      <head>
        <title>Print</title>
        <style>
        @page { size: auto;  margin: 1rem; }
          @media print {
            .button-action,
            .ant-btn {
              display: none !important;
            }
          }
        </style>
      </head>
      <body>
        ${printableContent}
      </body>
    </html>
  `;
    newWindow.document.body.innerHTML = printMarkup;
    newWindow.document.close();

    newWindow.print();
    newWindow.close();
  };

  useEffect(() => {
    getDocumentData();

    setIsStaff(getDataLogin()?.id_privilege !== 3);
  }, []);

  const renderContent = () => {
    if (loading) {
      return <Skeleton active paragraph={{ rows: 10 }} />;
    }
    if (!isSaved) {
      return (
        <div style={{ minHeight: 500 }}>
          <ReactQuill
            theme="snow"
            value={value}
            onChange={setValue}
            modules={modules}
          />
        </div>
      );
    }
    return (
      <>
        {/* load komponen quill di awal agar css nya aktif */}
        <div style={{ height: 0, overflow: "hidden" }}>
          <ReactQuill
            theme="snow"
            value={value}
            onChange={() => { }}
            readOnly={true}
            modules={modules}
          />
        </div>

        <div
          className="ql-editor"
          style={{
            border: 0,
            padding: 8,
            display: "block",
          }}
          dangerouslySetInnerHTML={{ __html: value }}
        />
      </>
    );
  };

  return (
    <div id="printable" style={{ width: "100%" }}>
      <Col span={24} style={{ padding: "0 16px" }}>
        <h2>Kebijakan & Peraturan CV Lautan Berkah Food</h2>
        <Flex
          gap="middle"
          justify="space-between"
          style={{ marginTop: -14, marginBottom: -14 }}
        >
          <p style={{ color: "#7c7979" }}>Pembaruan terakhir: {savedDate}</p>

          {!isPublic && (
            <div className="button-action" style={{ display: "flex" }}>
              {isStaff &&
                (!isSaved ? (
                  <Row gutter={[16, 0]}>
                    <Col span={12}>
                      <Button
                        type="primary"
                        variant="solid"
                        style={{ backgroundColor: "#ffa034" }}
                        onClick={() => setIsSaved(true)}
                      >
                        Cancel
                      </Button>
                    </Col>
                    <Col span={4}>
                      <Button
                        loading={loading}
                        type="primary"
                        onClick={handleSave}
                      >
                        Save
                      </Button>
                    </Col>
                  </Row>
                ) : (
                  <Button type="primary" onClick={() => handleEdit()}>
                    Edit
                  </Button>
                ))}

              <div style={{ display: "flex", gap: "0.5rem" }}>
                {isSaved && (
                  <Button
                    type="primary"
                    style={{ marginLeft: 8, backgroundColor: "#4caf50" }}
                    onClick={() => handlePrint()}
                    icon={<PrinterOutlined />}
                  >
                    Print
                  </Button>
                )}
                <UserManualButton />
              </div>
            </div>
          )}
        </Flex>
        <hr />
      </Col>
      <Col span={24}>
        {renderContent()}
      </Col>
    </div>
  );
};


PolicyComponent.propTypes = {
  isPublic: PropTypes.bool,
};

export default PolicyComponent;
